import {Container, Row, Col} from 'react-bootstrap';
import {useLanguageContext, useThemeContext} from '../../../../context';
import {observeActiveCustomers} from '../../../../pos-core/database/helpers';
import withObservables from '@nozbe/with-observables';
import {DEVICE_HEIGHT} from '../../../../constants';
import {useSearch} from '../../../../hooks';
import PosAppModal from '../PosAppModal';
import SearchBox from '../../SearchBox';
import Listitem from './ListItem';
import NonIdealScreen from '../../NonIdeal';
import usePermission from '../../../../hooks/usePermission';

const SelectedCustomerModal = ({toggle, setToggle, customers, handleSelect, order, handleCreateCustomer}) => {
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();
    const {text, setText, searchList} = useSearch(handleSearch);
    const userPermission = usePermission('customers');

    function handleClose(event) {
        setToggle(false);
    }

    const onChange = (event, key) => {
        let value = key || event?.target?.value || '';
        setText(value);
    };

    function handleSearch(val) {
        return customers.filter(x => x.name.toLowerCase().includes(val.toLowerCase()) || x.phone_number.toLowerCase().includes(val.toLowerCase()));
    }

    return (
        <PosAppModal
            className="selectCustomerModal"
            toggle={toggle}
            backCta={{
                name: 'backArrowIcon',
                fill: theme.barclaysBlue,
                width: '18',
                height: '18',
                viewBox: '0 0 18 18',
            }}
            handleClose={handleClose}
            rightCta={
                userPermission?.canCrud &&
                customers?.length && {
                    title: I18n.create_new_customer,
                    action: handleCreateCustomer,
                    iconName: 'add2Icon',
                    fill: theme.barclaysBlue,
                    width: '18',
                    height: '18',
                    viewBox: '0 0 18 18',
                }
            }
            title={I18n.add_customer}>
            <>
                {!customers.length == 0 && (
                    <SearchBox
                        type="pos"
                        placeholder={I18n.search_customer_name_phone_or_email}
                        prefix={{
                            name: 'search2Icon',
                            fill: theme.white,
                        }}
                        onChange={onChange}
                    />
                )}

                <Container fluid>
                    <Row className="justify-content-md-center">
                        <Col md={12}>
                            {customers.length ? (
                                <div
                                    className="selectCustomerListBox tableListMainBox"
                                    style={{
                                        height: DEVICE_HEIGHT - 150,
                                    }}>
                                    {(text ? searchList : customers).map((val, index) => (
                                        <Listitem order={order} key={index} customer={val} onPress={handleSelect} />
                                    ))}
                                </div>
                            ) : (
                                <NonIdealScreen
                                    heading={I18n.customer}
                                    subHeading={I18n.create_new_customer_and_add_to_sale}
                                    name="customerSquareIcon"
                                    fill={theme.white}
                                    primaryCta={
                                        userPermission?.canCrud
                                            ? {
                                                  title: I18n.create_customer,
                                                  action: handleCreateCustomer,
                                              }
                                            : null
                                    }
                                    isMultiStep={false}
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
            </>
        </PosAppModal>
    );
};

const enhance = withObservables([], () => ({
    customers: observeActiveCustomers(),
}));

export default enhance(SelectedCustomerModal);
